const DEFAULT_YOUTUBE_ORIGIN = 'https://screen.trillboards.com';

export const YOUTUBE_IFRAME_ALLOW = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
export const YOUTUBE_REFERRER_POLICY = 'strict-origin-when-cross-origin';

export const isBrightSignRuntime = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(
    window.__TRILLBOARDS_PLATFORM === 'brightsign'
    || window.__TRILLBOARDS_BRIGHTSIGN
    || window.BSDeviceInfo
    || String(window.navigator?.userAgent || '').toLowerCase().includes('brightsign')
  );
};

export const resolveYouTubeEmbedOrigin = () => {
  if (typeof window === 'undefined') return DEFAULT_YOUTUBE_ORIGIN;

  const origin = window.location?.origin;
  if (typeof origin === 'string' && /^https?:\/\//i.test(origin)) {
    return origin;
  }

  return DEFAULT_YOUTUBE_ORIGIN;
};

const normalizeYouTubeEmbedOrigin = (origin) => (
  typeof origin === 'string' && /^https?:\/\//i.test(origin)
    ? origin
    : DEFAULT_YOUTUBE_ORIGIN
);

export const buildYouTubeEmbedUrl = (videoId, options = {}) => {
  if (!videoId) return null;

  const host = options.privacyEnhanced || isBrightSignRuntime()
    ? 'https://www.youtube-nocookie.com'
    : 'https://www.youtube.com';
  const startSeconds = Number(options.startSeconds || 0);
  const params = [
    'autoplay=1',
    'mute=1',
    'loop=0',
    'controls=0',
    'modestbranding=1',
    'rel=0',
    'enablejsapi=1',
    `origin=${encodeURIComponent(normalizeYouTubeEmbedOrigin(options.origin || resolveYouTubeEmbedOrigin()))}`,
    'playsinline=1',
    'widgetid=1',
    'vq=highres',
    'quality=highres',
    'hd=1'
  ];

  if (Number.isFinite(startSeconds) && startSeconds > 0) {
    params.push(`start=${Math.floor(startSeconds)}`);
  }

  return `${host}/embed/${encodeURIComponent(videoId)}?${params.join('&')}`;
};

export const isYouTubePlayerErrorMessage = (eventData) => {
  let data = eventData;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (_) {
      return false;
    }
  }

  if (!data || typeof data !== 'object') return false;
  return data.event === 'onError'
    || (data.event === 'infoDelivery' && data.info && data.info.errorCode != null);
};

export const extractYouTubePlayerErrorCode = (eventData) => {
  let data = eventData;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (_) {
      return null;
    }
  }

  if (!data || typeof data !== 'object') return null;
  if (data.event === 'onError') return data.info;
  if (data.event === 'infoDelivery' && data.info && data.info.errorCode != null) {
    return data.info.errorCode;
  }
  return null;
};
